import { apiClient } from './api'

export interface VoiceRecordDebug {
  _id: string
  userId: string
  transcript: string
  aiResponse?: string
  language?: string
  status?: string
  nearbyYard?: string
  location?: { latitude: number; longitude: number }
  metadata?: Record<string, unknown>
  createdAt: string
}

export interface ApiLogEntry {
  _id: string
  method: string
  url: string
  status: number
  responseTime: number
  userId?: string
  userRole?: string
  requestBody?: Record<string, unknown>
  responseBody?: Record<string, unknown> | string
  ip: string
  userAgent: string
  error?: string
  timestamp: string
}

export interface PaginatedResponse<T> {
  data: T[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}

export interface VoiceRecordParams {
  page?: number
  limit?: number
  startDate?: string
  endDate?: string
  search?: string
  sort?: string
}

export interface ApiLogParams {
  page?: number
  limit?: number
  method?: string
  status?: string
  search?: string
  sort?: string
}

export function getVoiceRecords(params: VoiceRecordParams) {
  return apiClient.get<PaginatedResponse<VoiceRecordDebug>>('/debug/voice-records', { params })
}

export function getApiLogs(params: ApiLogParams) {
  return apiClient.get<PaginatedResponse<ApiLogEntry>>('/debug/api-logs', { params })
}
